import bg from '../assets/bg.png';
import knife from '../assets/knife.png';
import logo from '../assets/logo.png';
import overlaybg from '../assets/overlaybg.png';
import spoon from '../assets/spoon.svg';
import dining_hall from '../assets/dining_hall.png'
import findus from '../assets/findus.png';
import quote from '../assets/quote.png';
import pho1986 from '../assets/pho1986.png';
import hall_door from '../assets/hall_door.png';
import hall from '../assets/hall.png';
import logo_wall from '../assets/logo_wall.png';

const images = {
  bg,
  knife,
  logo,
  overlaybg,
  spoon,
  dining_hall,
  findus,
  quote,
  pho1986,
  hall_door,
  hall,
  logo_wall
};

export default images;
